// gsap.registerPlugin(ScrollTrigger);
// const tl = gsap.timeline();

// // Homepage Hero Slider
// const heroSlide = document.querySelectorAll(".header-slider-desktop .swiper-slide");
// var heroSlider = new Swiper(".header-slider-desktop", {
//   loop: true,
//   watchSlidesProgress: true,
//   effect: "fade",
//   fadeEffect: {
//     crossFade: true,
//   },
//   autoplay: {
//     delay: 5000,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: ".slide-swiper-pagination",
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".hero-button-next",
//     prevEl: ".hero-button-prev",
//   },
//   on: {
//     init: function () {
//       var slideIndex = this.realIndex;
//       sliderInt(slideIndex);
//     },
//     slideChangeTransitionStart: function () {
//       var slideIndex = this.realIndex;
//       sliderInt(slideIndex);
//     },
//   }
// });

// function sliderInt(slideIndex) {
//   heroSlide.forEach((img) => {
//     const index = img.getAttribute("data-swiper-slide-index");
//     if (index == slideIndex) {
//       img.classList.add("activeBG");
//     } else {
//       img.classList.remove("activeBG");
//     }
//   });
//   gsap.from(
//     ".activeBG .target_animate",
//     0.4, {
//       y: 80,
//       opacity: 0,
//       clipPath: "inset(100% 0 0 0)",
//       stagger: {
//         amount: 0.4,
//       }
//     }
//   );
// }

// // play pause functionality for hero slider
// var playPauseBtn = document.getElementById('playPauseBtn');
// var isPlaying = true;

// playPauseBtn.addEventListener('click', function () {
//   var swiperContainer = document.querySelector('.header-slider-desktop');
//   swiperContainer.classList.toggle('toggled-class');

//   if (isPlaying) {
//     heroSlider.autoplay.stop();
//   } else {
//     heroSlider.autoplay.start();
//   }
//   isPlaying = !isPlaying;
// });

gsap.registerPlugin(ScrollTrigger);
const tl = gsap.timeline();

// Homepage Hero Slider
const SLIDE_TRANSITION_DURATION = 500;
const SLIDE_CHANGE_DELAY = 5000;

let heroSlider = null;
let isPlaying = true;
let nextSlidePlay = false;
let headerSlideDirection = "next";
let headerSlideTransitionHandled = false;

function getHeaderSlideCount(swiper) {
  const blockIds = new Set();

  swiper.slides.forEach((slide) => {
    const blockId = slide.getAttribute("data-block-id");
    if (blockId) blockIds.add(blockId);
  });

  return blockIds.size;
}

function resolveHeaderSlideDirection(swiper) {
  const previous = swiper.previousRealIndex;
  const current = swiper.realIndex;
  const total = getHeaderSlideCount(swiper);

  if (previous === undefined || current === undefined || previous === current) {
    return headerSlideDirection;
  }

  const diff = current - previous;

  if (total > 1) {
    if (diff === total - 1) return "prev";
    if (diff === -(total - 1)) return "next";
  }

  return diff > 0 ? "next" : "prev";
}

function playHeaderSlideTransition(swiper, direction, isInitial = false) {
  headerSlideDirection = direction;
  sliderInt(swiper, swiper.realIndex, direction, isInitial);
  resetPlayPauseProgress();
}

function resetHiddenHeaderSlideText(swiper) {
  if (!swiper?.slides?.length) return;

  swiper.slides.forEach((slide) => {
    if (
      slide.classList.contains("swiper-slide-active") ||
      slide.classList.contains("swiper-slide-prev") ||
      slide.classList.contains("swiper-slide-next")
    ) {
      return;
    }

    const content = slide.querySelector(".slider_content");
    if (!content) return;

    gsap.killTweensOf(content);
    gsap.set(content, { x: 0, opacity: 1, clearProps: "transform" });
  });
}

function showHeaderSlideTextStatic(swiper) {
  if (!swiper?.slides?.length) return;

  const activeSlide = swiper.slides[swiper.activeIndex];
  const contentGroup = activeSlide?.querySelector(".slider_content");
  if (!contentGroup) return;

  gsap.killTweensOf(contentGroup);
  gsap.set(contentGroup, { x: 0, opacity: 1, clearProps: "transform" });
}

function animateHeaderSlideText(swiper, direction = "next") {
  if (!swiper?.slides?.length) return;

  const activeSlide = swiper.slides[swiper.activeIndex];
  const contentGroup = activeSlide?.querySelector(".slider_content");
  if (!contentGroup) return;

  gsap.killTweensOf(contentGroup);

  const fromX = direction === "prev" ? -56 : 56;

  gsap.set(contentGroup, { x: fromX, opacity: 0 });
  gsap.to(contentGroup, {
    x: 0,
    opacity: 1,
    duration: 0.9,
    delay: 0.22,
    ease: "power3.out",
    overwrite: "auto",
    onComplete: () => {
      gsap.set(contentGroup, { clearProps: "transform" });
      resetHiddenHeaderSlideText(swiper);
    },
  });
}

function sliderInt(swiper, slideIndex, direction = "next", isInitial = false) {
  const heroSlide = swiper.el.querySelectorAll(".swiper-slide");

  heroSlide.forEach((slide) => {
    const index = slide.getAttribute("data-swiper-slide-index");
    if (index == slideIndex) {
      slide.classList.add("activeBG");
    } else {
      slide.classList.remove("activeBG");
    }
  });

  headerSlideDirection = direction;

  if (isInitial) {
    showHeaderSlideTextStatic(swiper);
    return;
  }

  animateHeaderSlideText(swiper, direction);
}

function resetPlayPauseProgress() {
  const heroSliderEl = document.querySelector(".header-slider-desktop");
  if (!heroSliderEl || heroSliderEl.classList.contains("toggled-class")) return;

  const progress = heroSliderEl.querySelector(".header-slider-play-pause__progress");
  if (!progress) return;

  progress.style.animation = "none";
  progress.getBoundingClientRect();
  progress.style.animation = "";
}

function bindHeaderSliderControls() {
  const playPauseBtn = document.querySelector("[data-play-pause-btn]");
  if (!playPauseBtn || playPauseBtn.dataset.bound === "true") return;

  playPauseBtn.dataset.bound = "true";
  playPauseBtn.addEventListener("click", function () {
    const swiperContainer = document.querySelector(".header-slider-desktop");
    if (!swiperContainer || !heroSlider) return;

    swiperContainer.classList.toggle("toggled-class");
    if (isPlaying) {
      heroSlider.autoplay.pause();
      playPauseBtn.setAttribute("aria-label", "Play slideshow");
    } else if (nextSlidePlay) {
      nextSlidePlay = false;
      heroSlider.autoplay.start();
      playPauseBtn.setAttribute("aria-label", "Pause slideshow");
      resetPlayPauseProgress();
    } else {
      heroSlider.autoplay.resume();
      playPauseBtn.setAttribute("aria-label", "Pause slideshow");
      resetPlayPauseProgress();
    }
    isPlaying = !isPlaying;
  });
}

function bindHeaderSliderNavigation() {
  if (!heroSlider?.el) return;

  heroSlider.el.querySelectorAll(".hero-button-prev, .hero-button-next").forEach((btn) => {
    if (btn.dataset.navBound === "true") return;
    btn.dataset.navBound = "true";

    btn.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();

      if (btn.classList.contains("hero-button-prev")) {
        heroSlider.slidePrev();
      } else {
        heroSlider.slideNext();
      }
    });
  });
}

function initHeaderSlider() {
  const heroSliderEl = document.querySelector(".header-slider-desktop");
  if (!heroSliderEl || typeof Swiper !== "function") return;

  if (heroSliderEl.swiper) {
    heroSliderEl.swiper.destroy(true, true);
  }

  heroSliderEl.querySelectorAll(".hero-button-prev, .hero-button-next").forEach((btn) => {
    delete btn.dataset.navBound;
  });

  heroSliderEl.style.setProperty(
    "--section-autoplay-duration",
    `${(SLIDE_TRANSITION_DURATION + SLIDE_CHANGE_DELAY) / 1000}s`
  );

  heroSlider = new Swiper(".header-slider-desktop", {
    loop: true,
    watchSlidesProgress: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: SLIDE_TRANSITION_DURATION + SLIDE_CHANGE_DELAY,
      disableOnInteraction: true,
    },
    speed: SLIDE_TRANSITION_DURATION,
    pagination: {
      el: ".slide-swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".hero-button-next",
      prevEl: ".hero-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
    },
    on: {
      init: function () {
        playHeaderSlideTransition(this, "next", true);
      },
      slideChangeTransitionStart: function () {
        const swiper = this;

        requestAnimationFrame(() => {
          if (headerSlideTransitionHandled) {
            headerSlideTransitionHandled = false;
            return;
          }

          playHeaderSlideTransition(swiper, resolveHeaderSlideDirection(swiper));
        });
      },
      slideNextTransitionStart: function () {
        headerSlideTransitionHandled = true;
        playHeaderSlideTransition(this, "next");
        nextSlidePlay = true;
        if (!isPlaying) {
          heroSlider.autoplay.stop();
        } else {
          heroSlider.autoplay.start();
        }
      },
      slidePrevTransitionStart: function () {
        headerSlideTransitionHandled = true;
        playHeaderSlideTransition(this, "prev");
        nextSlidePlay = true;
        if (!isPlaying) {
          heroSlider.autoplay.stop();
        } else {
          heroSlider.autoplay.start();
        }
      },
    },
  });

  window.headerSliderInstance = heroSlider;
  isPlaying = true;
  nextSlidePlay = false;
  heroSliderEl.classList.remove("toggled-class");

  bindHeaderSliderControls();
  bindHeaderSliderNavigation();
}

window.initHeaderSlider = initHeaderSlider;

function destroyHeaderSlider(sectionId) {
  const section = document.querySelector(`#shopify-section-${sectionId} .header-slider-desktop`);
  if (!section?.swiper) return;

  section.swiper.destroy(true, true);
  if (window.headerSliderInstance === section.swiper) {
    window.headerSliderInstance = null;
    heroSlider = null;
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeaderSlider);
} else {
  initHeaderSlider();
}

document.addEventListener("shopify:section:load", (event) => {
  const section = document.querySelector(
    `#shopify-section-${event.detail.sectionId} .header-slider-desktop`
  );
  if (section) initHeaderSlider();
});

document.addEventListener("shopify:section:unload", (event) => {
  destroyHeaderSlider(event.detail.sectionId);
});

document.addEventListener("visibilitychange", function () {
  if (!heroSlider?.autoplay) return;

  if (document.visibilityState === "hidden") {
    heroSlider.autoplay.pause();
  } else if (!isPlaying) {
    heroSlider.autoplay.resume();
  }
});









// auto scroll image section
window.addEventListener('load', function () {
  if (window.Shopify?.designMode) return;

  if (window.innerWidth >= 768) {
    const races = document.querySelector(".auto_scroll_main");
    const progressBar = document.querySelector('.progress_inner');
    const progressMain = document.querySelector('.progress-main');
    
    if (!races || !progressBar || !progressMain) return;

    const containerWidth = progressMain.offsetWidth;

    function getScrollAmount() {
      let racesWidth = races.scrollWidth;
      return -(racesWidth - window.innerWidth);
    }
    const timeline = gsap.timeline();

    timeline.to(races, {
      x: getScrollAmount,
      ease: "none"
    });

    timeline.to('.progress_inner', {
      x: () => {
        return containerWidth - (195)
      },
      ease: "none"
    }, 0)

    ScrollTrigger.create({
      trigger: ".coll_pin_section",
      start: "top top",
      end: () => `+=${getScrollAmount() * -1}`,
      pin: true,
      animation: timeline,
      scrub: true,
      invalidateOnRefresh: true,
    });

    ScrollTrigger.observe({
      target: ".auto_scroll_container",
      type: "pointer,touch",

      onDrag: (self) => {
        gsap.to(window, {
          scrollTo: {
            y: `+=${self.deltaX * 10}`
          }
        });
      }
    });

    ScrollTrigger.addEventListener("refreshInit", getScrollAmount);
  }
});